

















































































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig, UseModal } from "@/components/root/modal";
import VirtualTable from "@/components/table/VirtualTable.vue";
import TableRow from "./TableRow.vue";
import { getTableConfig } from "./table.config";
import {
  computed,
  onBeforeUnmount,
  onMounted,
  Ref,
  ref,
} from "@vue/composition-api";
import { EventBus } from "@/eventbus";

import { emptyFn } from "@/fp";
import * as menus from "./menus";
import { UseCollection } from "@/common/composition/use-collection";
import { AxisType, CoordinateInputTier1Tier2 } from "@/gql/types";
import { EntitiesModalProps } from "./model";
import * as api from "./api";
import EventsModalVue from "../events-modal/EventsModal.vue";
import InfoTypesDropDown from "@/components/modals/entities-table-modal/InfoTypesDropdown2.vue";
import { SharedState } from "@/common/state";
import { cord } from "@/gql/lib";
import { InformationType, POPULATION_TYPE } from "@/common/models";
import { EventsModalProps } from "../events-modal/model";
import { pxToRem, remToPx } from "@/common/dom.functions";
import DropDownSimple from "@/components/dropdown/DropDownSimple.vue";
import { UseDropdownItems } from "@/common/composition/dropdown-items";
import { GqlCallsKey } from "@/mock/demo/gql.resolver";
import { UsePopup } from "@/components/root/popup/popup.state";
export default Vue.extend({
  components: {
    Modal,
    VirtualTable,
    InfoTypesDropDown,
    DropDownSimple,
  },
  props: ["modalData"],
  setup(props, { emit }) {
    const modal_props = computed(() => props.modalData as EntitiesModalProps);

    const get_modal_with_by_type = (type: POPULATION_TYPE) => {
      switch (type) {
        case POPULATION_TYPE.ORGANIZATION:
        case POPULATION_TYPE.CONTACT:
          return "95rem";
        default:
          return "115rem";
      }
    };

    const modal_config = computed(() => {
      return {
        title: "",
        desc: "",
        blank: true,
        withTopRightCloseBtn: true,
        backdropDismiss: true,
        width: get_modal_with_by_type(modal_props.value.type),
        height: Math.min(65, pxToRem(innerHeight) * 0.9) + "rem",
      } as ModalConfig;
    });

    // ========== context labels =========
    const [
      context_labels,
      selected_context_label,
      set_selected_context_label,
      init_context_labels_seed,
    ] = UseDropdownItems<{ id: string; name: string }>();

    const on_selected_context_label_changed = async (label_id: string) => {
      set_selected_context_label(label_id);
      // @ts-ignore
      selected_label.value = SharedState.getInfoType(label_id);
      console.log("label_id:  ", label_id);
      console.log("selected_label :", selected_label.value);
      const { x, y, z } = coordinate.value;
      if (x.type === AxisType.ContentLabel) {
        coordinate.value = {
          x: cord(AxisType.ContentLabel, [label_id]),
          y,
          z,
        };
      } else {
        coordinate.value = {
          x,
          y: cord(AxisType.ContentLabel, [label_id]),
          z,
        };
      }
      await reload_data();
    };

    // =========== info types =============
    const selected_label = ref(
      SharedState.default_label.value as InformationType
    );

    const show_info_dropdown = computed(() => selected_label.value);

    const l0_l1: Ref<[string, string]> = ref(["", ""]);

    const on_info_type_changed = async (label_id: string) => {
      selected_label.value = SharedState.allInfoTypes.value[label_id];
      const { x, y, z } = coordinate.value;
      if (x.type === AxisType.ContentLabel) {
        coordinate.value = {
          x: cord(AxisType.ContentLabel, [label_id]),
          y,
          z,
        };
      } else {
        coordinate.value = {
          x,
          y: cord(AxisType.ContentLabel, [label_id]),
          z,
        };
      }
      await reload_data();
    };
    // =================================

    const entities_collection = UseCollection<
      any,
      { cursor: string; coordinate: CoordinateInputTier1Tier2 }
    >(async ({ cursor, coordinate }) => {
      return await api.get_entities({
        type: modal_props.value.type,
        cursor,
        coordinate,
        target_axis: modal_props.value.target_axis,
      });
    });

    const load_more_entities = async () => {
      if (entities_collection.has_more.value) {
        await entities_collection.load_more_items();
      }
    };

    const selected_entity_id = ref("");

    const export_table_as_csv = async (event: MouseEvent) => {
      if (SharedState.is_biz_user.value) {
        if (SharedState.restrictions.is_restricted_app("reports")) {
          SharedState.restrictions.show_restrictions_modal("app", "Reports");
          return;
        }
      }
      let title = modal_props.value.title;
      if (title.search("<info_type>") !== -1) {
        title = title.replace("<info_type>", selected_label.value?.labelName);
      }

      const { state: csv_state } = await import(
        "@/views/reports/data/csv/state.csv"
      );
      const payload = {
        possible_call_tags: ["entities.get"],
        table_config: table_config.value,
        title,
        tags: {
          entity_type: modal_props.value.type,
        },
      };

      if (SharedState.FeatureHelper.is_enabled("csv_report_scheduler")) {
        const res = await UsePopup.showActionPopup({
          type: "TextAndIconDisplayPopup",
          items: [
            { icon: "CSV", text: "Generate csv report" },
            { icon: "Calendar", text: "Schedule csv report" },
          ],
          width: remToPx(15),
          event,
          position: "bottom-left",
        });
        if (res.type == "canceled") {
          return;
        }
        if (res.action == "Schedule csv report") {
          // @ts-ignore
          csv_state.schedule_gql_csv_report(payload);
        } else {
          // @ts-ignore
          csv_state.create_gql_report(payload);
        }
      } else {
        // @ts-ignore
        csv_state.create_gql_report(payload);
      }
    };

    const table_config = computed(() => getTableConfig(modal_props.value.type));

    const coordinate: Ref<CoordinateInputTier1Tier2> = ref({
      x: cord(AxisType.None, []),
      y: cord(AxisType.None, []),
      z: {
        type: "Month",
        values: [],
      },
    } as CoordinateInputTier1Tier2);

    const on_show_events = async (p: {
      item: any;
      mode: "events" | "files";
    }) => {
      SharedState.ifIsPayingUser(
        async () => {
          const content_label_id =
            coordinate.value.x.type === AxisType.ContentLabel
              ? coordinate.value.x.values?.[0]
              : coordinate.value.y.type === AxisType.ContentLabel
              ? coordinate.value.y.values?.[0]
              : undefined;
          const content_label_name = content_label_id
            ? SharedState.getInfoType(content_label_id)?.labelName
            : selected_label.value?.labelName;
          const title = modal_props.value.events.title(p.item, content_label_name);
          const files_title = modal_props.value.files_title(
            p.item,
            content_label_name
          );
          const coordinates = modal_props.value.events.coordinate(
            p.item,
            content_label_id || selected_label.value?.id
          );
          console.log("coordinates : ", coordinates);
          await UseModal().show(EventsModalVue, {
            title,
            files_title,
            show_back: true,
            source: modal_props.value.source || "",
            hide_filters: modal_props.value.events.hide_filters || [],
            coordinates: [coordinates],
          } as EventsModalProps);
        },
        { premium_modal_key: "where-popup-2024" }
      );
    };

    const on_show_table_row_menu = async (p: {
      item: any;
      event: MouseEvent;
    }) => {
      console.log("on_show_table_row_menu :", p.item);
      const res = await menus.employee_menu({
        ...p,
        info_types: modal_props.value.info_types,
      });
      if (res === "close") {
        // close the modal
        emit("cancel");
      }
    };

    const subs = {
      show_events: emptyFn(),
      show_files: emptyFn(),
      show_menu: emptyFn(),
      show_event_menu: emptyFn(),
    };

    const reload_data = async () => {
      entities_collection.clear();
      await entities_collection.load_items({
        cursor: "",
        coordinate: coordinate.value,
      });
    };

    onMounted(async () => {
      if (modal_props.value.using_context_dropdown) {
        const ctx_label_id = modal_props.value.info_types[0];
        const all_context_labels = [
          ...SharedState.context_labels.value,
          ...SharedState.folders_context_labels.value,
        ];
        // @ts-ignore
        selected_label.value = all_context_labels.find(
          (f) => f.id === ctx_label_id
        );
        init_context_labels_seed(
          all_context_labels
            .filter((f) => modal_props.value.info_types.includes(f.id))
            .map((d) => {
              return {
                id: d.id,
                name: d.labelName,
              };
            })
            .sort(
              (a, b) =>
                modal_props.value.info_types.indexOf(a.id) -
                modal_props.value.info_types.indexOf(b.id)
            )
        );
        set_selected_context_label(context_labels.value[0].id);
      } else {
        const label_id = modal_props.value.info_types[0];
        selected_label.value = SharedState.allInfoTypes.value[label_id];
        if (
          modal_props.value.info_types.length > 0 &&
          show_info_dropdown.value
        ) {
          // @ts-ignore
          l0_l1.value =
            selected_label.value.generation === 0
              ? [selected_label.value.id, ""]
              : [selected_label.value.parentId, selected_label.value.id];
        }
      }

      coordinate.value = modal_props.value.coordinate;

      subs.show_events = EventBus.listen("events", on_show_events);
      //  subs.show_files = EventBus.listen("files", on_show_files);
      subs.show_menu = EventBus.listen("showMenu", on_show_table_row_menu);
      // subs.show_event_menu = EventBus.listen("showEventMenu", menus.event_menu);

      entities_collection.clear();
      await reload_data();
    });

    onBeforeUnmount(() => Object.values(subs).forEach((unsub) => unsub()));

    return {
      modal_config,
      table_config,
      TableRow,
      selected_entity_id,
      is_loading: entities_collection.is_loading,
      has_no_results: entities_collection.has_no_results,
      items: entities_collection.items,
      load_more_entities,
      export_table_as_csv,
      l0_l1,
      show_info_dropdown,
      on_info_type_changed,
      selected_label,
      context_labels,
      selected_context_label,
      on_selected_context_label_changed,
      has_reports_enabled: SharedState.FeatureHelper.is_enabled("reports"),
    };
  },
});
